"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubTopics = exports.FootykidsSiteType = exports.PaymentChannel = exports.PaymentMethod = exports.OrderStatus = exports.PaymentStatus = exports.State = exports.Day = exports.EmailType = exports.FLDSettingsType = exports.NotificationType = exports.AdminType = void 0;
var AdminType;
(function (AdminType) {
    AdminType["SUPER"] = "SUPER";
    AdminType["SUPPORT"] = "SUPPORT";
})(AdminType = exports.AdminType || (exports.AdminType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["FKL"] = "FKL";
    NotificationType["FKA"] = "FKA";
    NotificationType["FLD"] = "FLD";
    NotificationType["FKORIGINAL"] = "FKORIGINAL";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var FLDSettingsType;
(function (FLDSettingsType) {
    FLDSettingsType["SHIPPING_CITY_STATE"] = "SHIPPING_CITY_STATE";
    FLDSettingsType["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    FLDSettingsType["IS_MAINTENANCE"] = "IS_MAINTENANCE";
})(FLDSettingsType = exports.FLDSettingsType || (exports.FLDSettingsType = {}));
var EmailType;
(function (EmailType) {
    EmailType["FLD_ORDER_SUCCESS"] = "FLD_ORDER_SUCCESS";
    EmailType["FLD_ORDER_CONFIRM"] = "FLD_ORDER_CONFIRM";
    EmailType["FLD_ORDER_CANCEL"] = "FLD_ORDER_CANCEL";
    EmailType["FLD_ORDER_SHIPPED"] = "FLD_ORDER_SHIPPED";
    EmailType["FLD_ORDER_ADMIN"] = "FLD_ORDER_ADMIN";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var Day;
(function (Day) {
    Day["MONDAY"] = "MONDAY";
    Day["TUESDAY"] = "TUESDAY";
    Day["WEDNESDAY"] = "WEDNESDAY";
    Day["THURSDAY"] = "THURSDAY";
    Day["FRIDAY"] = "FRIDAY";
    Day["SATURDAY"] = "SATURDAY";
    Day["SUNDAY"] = "SUNDAY";
})(Day = exports.Day || (exports.Day = {}));
var State;
(function (State) {
    State["KUALALUMPUR"] = "Kuala Lumpur";
    State["LABUAN"] = "Labuan";
    State["PUTRAJAYA"] = "Putra Jaya";
    State["JOHOR"] = "Johor";
    State["KEDAH"] = "Kedah";
    State["KELANTAN"] = "Kelantan";
    State["NEGERISEMBILAN"] = "Negeri Sembilan";
    State["PAHANG"] = "Pahang";
    State["PERAK"] = "Perak";
    State["PERLIS"] = "Perlis";
    State["PENANG"] = "Penang";
    State["SABAH"] = "Sabah";
    State["SARAWAK"] = "Sarawak";
    State["SELANGOR"] = "Selangor";
    State["TERENGGANU"] = "Terengganu";
})(State = exports.State || (exports.State = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FAILED"] = "UNSUCCESSFUL TRANSACTION";
    PaymentStatus["ERROR"] = "ERROR";
    PaymentStatus["PENDINGPAYMENT"] = "PENDING PAYMENT";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["TOREFUND"] = "TO REFUND";
    PaymentStatus["REFUNDED"] = "REFUNDED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["SUCCESSFUL"] = "SUCCESSFUL";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["SHIPPED"] = "SHIPPED";
    OrderStatus["FAILED"] = "FAILED";
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["SHIPPING_FAILED"] = "SHIPPING FAILED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["fpx"] = "FPX";
    PaymentMethod["creditcard"] = "CREDIT CARD";
    PaymentMethod["paypal"] = "PAYPAL";
    PaymentMethod["maybank2u"] = "MAYBANK2U";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var PaymentChannel;
(function (PaymentChannel) {
    PaymentChannel["TOYYIBPAY"] = "TOYYIBPAY";
    PaymentChannel["STRIPE"] = "STRIPE";
    PaymentChannel["PAYPAL"] = "PAYPAL";
    PaymentChannel["BILLPLZ"] = "BILLPLZ";
    PaymentChannel["MAYBANK2U"] = "MAYBANK2U";
    PaymentChannel["TODECIDE"] = "TODECIDE";
})(PaymentChannel = exports.PaymentChannel || (exports.PaymentChannel = {}));
var FootykidsSiteType;
(function (FootykidsSiteType) {
    FootykidsSiteType["FLDSTORE"] = "FLDSTORE";
    FootykidsSiteType["FOOTYKIDS"] = "FOOTYKIDS";
    FootykidsSiteType["LEAGUE"] = "LEAGUE";
    FootykidsSiteType["ACADEMY"] = "ACADEMY";
})(FootykidsSiteType = exports.FootykidsSiteType || (exports.FootykidsSiteType = {}));
var PubSubTopics;
(function (PubSubTopics) {
    PubSubTopics["NOTIFICATION"] = "NOTIFICATION";
    PubSubTopics["FLD_PAYMENT"] = "FLD_PAYMENT";
})(PubSubTopics = exports.PubSubTopics || (exports.PubSubTopics = {}));
//# sourceMappingURL=Enums.js.map